export const WEEKEND_WORK_REQUESTS_PATH = "/requests/weekend-work";
